import { Country, CountryState } from 'types';

export const isRegionSupported = (country: Country | null, state: CountryState | null) => {
  if (!country) return true;

  const hasStates = country && !country.finalRegion;
  if (hasStates) return !state || state.allowCrypto;
  if (country) return country.allowCrypto;

  return true;
};
